module.exports = __webpack_public_path__ + "assets/img/mecha-btn-a755084e.png";